import { render } from "./HomepageBaluchonalzheimer.vue?vue&type=template&id=1da05f4c&scoped=true"
import script from "./HomepageBaluchonalzheimer.vue?vue&type=script&lang=js"
export * from "./HomepageBaluchonalzheimer.vue?vue&type=script&lang=js"

import "./HomepageBaluchonalzheimer.vue?vue&type=style&index=0&id=1da05f4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da05f4c"]])

export default __exports__